import PropTypes from 'prop-types'
import { CloseIcon } from '../../assets/svgs/icons'
import { ModalComponent } from '../ModalComponent'
import styles from './styles.module.css'
import { t } from 'i18next'

export const ArtPendingPopUp = ({
  isOpen,
  onClose,
  onContinue,
  onDiscard,
}) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      className={styles.modalContainer}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {t('popup_art_generation_pending.title') || 'Você tem uma arte em geração pendente'}
          </h2>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className={styles.closeButton}
              aria-label={t('popup_art_generation_pending.close') || 'Fechar'}
            >
              <CloseIcon color="#000" size="28px" />
            </button>
          )}
        </div>
        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={onContinue}
          >
            {t('popup_art_generation_pending.button1') || 'Continuar a geração de arte'}
          </button>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onDiscard}
          >
            {t('popup_art_generation_pending.button2') || 'Descartar e começar nova'}
          </button>
        </div>
      </div>
    </ModalComponent>
  )
}

ArtPendingPopUp.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  onDiscard: PropTypes.func,
}

export default ArtPendingPopUp
